<template>
  <div class="anonymous-snapshot-wrap">
    <div class="top-cards-wrap mb-3">
      <v-row>
        <v-col class="col-md-8 col-lg-8 col-12 pr-0">
          <v-row class="mx-0 my-0" style="padding-left:18px;">
            <div sm3 md3 class="anonymous-employees-cards engagement-score py-0 ml-0">
              <v-card class="elevation-0 am-card">
                <p class="px-3 pt-3 my-0 score-card text-sm-left text-capitalize" style="">
                  Total Messages
                </p>
                <div v-if="report && report.total_count >= 0" class="d-inline-flex w-100">
                  <h1 class="score-card heading text-center" style="width:60%"
                    v-if="report && report.total_count">
                    {{ report.total_count }}
                  </h1>
                  <h1 class="score-card heading text-center" style="width:60%"
                    v-else>
                    0
                  </h1>
                </div>
                <div v-else>
                  <div class="d-flex flex-row flex-wrap align-center justify-center fill-height" style="height:120px">
                    <v-flex class="text-center">
                      <strong class="body-2 grey--text">
                        Not enough data to generate analysis
                      </strong>
                    </v-flex>
                  </div>
                </div>
              </v-card>
            </div>

            <!-- Messages Assigned -->
            <div sm3 md3 class="anonymous-employees-cards engagement-score py-0">
              <v-card class="elevation-0 am-card">
              <p class="px-3 pt-3 my-0 score-card text-capitalize text-sm-left" style=""> Messages Assigned </p>
              <div v-if="report && report.assigned_count >= 0" class="d-inline-flex w-100">
                <h1 class="score-card count pull-right heading text-center" style="font-size: 120px;
                  font-weight: 300;
                  margin: 0px auto;"
                  v-if="report && report.assigned_count">
                    {{ report.assigned_count }}
                  <!-- <p class="text-muted  percentage" style="color: #aca3d1;" v-if="report.assigned_percentage"> {{ report.assigned_percentage }}% </p> -->
                </h1>

                <h1 class="score-card heading text-center" style="font-size: 120px;
                  font-weight: 300;
                  margin: 0px auto;"
                  v-else>
                  0
                </h1>
              </div>
              <div v-else>
                <div class="d-flex flex-row flex-wrap align-center justify-center fill-height" style="height:120px">
                  <v-flex class="text-center">
                    <strong class="body-2 grey--text">
                      Not enough data to generate analysis
                    </strong>
                  </v-flex>
                </div>
              </div>
              </v-card>
            </div>

            <!-- Conversations Initiated -->
            <div sm3 md3 class="anonymous-employees-cards engagement-score py-0">
              <v-card class="elevation-0 am-card">
              <p class="px-3 pt-3 my-0 score-card text-capitalize text-sm-left headding" style=""> Conversations Initiated </p>
              <div v-if="report && report.initiated_count >= 0" class="d-inline-flex w-100">
                <h1 class="score-card count pull-right heading text-center" style="font-size: 120px;
                  font-weight: 300;
                  margin: 0px auto;"
                  v-if="report && report.initiated_count">
                    {{ report.initiated_count }}
                  <!-- <p class="text-muted percentage" style="color: #aca3d1;" v-if="report.initiated_percentage"> {{ report.initiated_percentage }}% </p> -->
                </h1>
                <h1 class="score-card heading text-center" style="font-size: 120px;
                  font-weight: 300;
                  margin: 0px auto;"
                  v-else>
                  0
                </h1>
              </div>
              <div v-else>
                <div class="d-flex flex-row flex-wrap align-center justify-center fill-height" style="height:120px">
                  <v-flex class="text-center">
                    <strong class="body-2  grey--text">
                      Not enough data to generate analysis
                    </strong>
                  </v-flex>
                </div>
              </div>
              </v-card>
            </div>

            <!-- Conversations Resolved -->
            <div sm3 md3 class="anonymous-employees-cards engagement-score py-0">
              <v-card class="elevation-0 am-card">
                <p class="px-3 pt-3 my-0 score-card text-capitalize text-sm-left" style=""> Conversations Resolved </p>
                <div v-if="report && report.resolved_count >= 0" class="d-inline-flex w-100">
                  <h1 class="score-card count pull-right heading text-center" style="font-size: 120px;
                    font-weight: 300;
                    margin: 0px auto;"
                    v-if="report && report.resolved_count">
                      {{ report.resolved_count }}
                    <!-- <p class="text-muted  percentage" style="color: #aca3d1;" v-if="report.resolved_percentage"> {{ report.resolved_percentage }}% </p> -->
                  </h1>
                  <h1 class="score-card heading text-center" style="font-size: 120px;
                    font-weight: 300;
                    margin: 0px auto;"
                    v-else>
                    0
                  </h1>
                </div>
                <div v-else>
                  <div class="d-flex flex-row flex-wrap align-center justify-center fill-height" style="height:120px">
                    <v-flex class="text-center">
                      <strong class="body-2  grey--text">
                        Not enough data to generate analysis
                      </strong>
                    </v-flex>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="col-12 pl-0" >
              <v-card class="elevation-0">
                <div class="anonymous-report-cards">
                  <p class="pa-3 text-left mb-0  text-capitalize"> Anonymous Message Assignee </p>
                  <v-row class="w-100 mx-0 my-0" style="border-bottom:1px solid #dadce0;border-top:1px solid #dadce0;">
                    <v-col class="col-4">
                      {{ table.headers[0] }}
                    </v-col>
                    <v-col class="col-2">
                      {{ table.headers[1] }}
                    </v-col>
                    <v-col class="col-2">
                      {{ table.headers[2] }}
                    </v-col>
                    <v-col class="col-2">
                      {{ table.headers[3] }}
                    </v-col>
                    <v-col class="col-2">
                      Action
                    </v-col>
                  </v-row>
                  <div style="max-height:345px; overflow-y:auto; overflow-x:hidden;">
                    <v-row class="w-100 mx-0 my-0" style="border-bottom:1px solid #dadce0;" v-for="(item, index) in table.team" :key="index">
                      <v-col class="col-4">
                        <div class="d-flex flex-row flex-wrap align-center">
                            <v-flex xs3>
                              <v-avatar size="40px" class="mr-3 text-center" :color="getColor(item)" style="max-width:40px;">
                                <img :src="item.profilePicture" alt="employee.display_name" v-show="item.profilePicture">
                                <span class="white--text" style="font-size:16px" v-show="!item.profilePicture">{{getAvatar(item)}}</span>
                              </v-avatar>
                            </v-flex>
                            <v-flex xs9 class="pl-2">
                              <p class="mb-0">
                                  {{item.user_name}}
                              </p>
                              <small class="text-muted d-inline-flex"> Department : {{ item.user_department }} </small>
                              <small class="text-muted d-inline-flex"> Location : {{ item.user_location }} </small>
                            </v-flex>
                          </div>
                      </v-col>
                      <v-col class="col-2">
                        <span v-if="item.total >= 0">
                          {{item.total}}
                        </span>
                        <span v-else class=" grey--text"> - </span>
                      </v-col>
                      <v-col class="col-2">
                        <span v-if="item.responded >= 0">
                          {{item.responded}}
                        </span>
                        <span v-else class=" grey--text"> - </span>
                      </v-col>
                      <v-col class="col-2">
                        <span v-if="item.resolved >= 0">
                          {{item.resolved}}
                        </span>
                        <span v-else class=" grey--text"> - </span>
                      </v-col>
                      <v-col class="col-2">
                        <a style="color: rgba(0, 0, 0, 0.54); padding: 5px; border: 1px solid darkgrey; border-radius: 3px;" class="employeeViewDetails" @click.stop="filterData(item.user_email)"> View details </a>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </div>
          </v-row>
        </v-col>
        <v-col class="col-md-4 col-lg-4 col-12">
          <v-row class="pr-3">
            <!-- Anonymity Rate -->
            <div class="anonymous-employees-cards1 col-12 engagement-score py-0  mr-0">
              <v-card class="elevation-0">
                <p class="px-3 pt-3 my-0 score-card text-capitalize text-sm-left" style=""> Anonymity Rate (%)</p>
                <div v-if="report && report.anonymity_percentage >= 0" class="d-inline-flex w-100">
                  <h1 class="score-card count heading text-center" style="font-size: 120px;
                    font-weight: 300;
                    margin: 0px auto;"
                    v-if="report && report.anonymity_percentage">
                      {{ report.anonymity_percentage }}
                    <!-- <p class="text-muted lighten-2  percentage" style="color: #aca3d1;" v-if="report.anonymity_variation">
                      {{ Math.abs(report.anonymity_variation) }}%
                    </p>
                    <span  style="position:relative;left:5px;top:-35px"  v-if="report.anonymity_variation < 0">
                      <v-icon style="font-size:15px;color:green;"> fas fa-arrow-down </v-icon>
                    </span>
                    <span style="position:relative;left:5px;top:-35px"  v-if="report.anonymity_variation > 0">
                      <v-icon style="font-size:15px;color:red;"> fas fa-arrow-up </v-icon>
                    </span> -->
                  </h1>
                  <h1 class="score-card heading text-center" style="font-size: 120px;
                    font-weight: 300;
                    margin: 0px auto;"
                    v-else>
                    0
                  </h1>
                </div>
                <div v-else>
                  <div class="d-flex flex-row flex-wrap align-center justify-center fill-height" style="height:120px">
                    <v-flex class="text-center">
                      <strong class="body-2  grey--text">
                        Not enough data to generate analysis
                      </strong>
                    </v-flex>
                  </div>
                </div>
                <div id="anonymityRate" class="py-1"></div>
              </v-card>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
// import { VAlert, VAvatar } from 'vuetify';
// import Anychart from 'anychart';
// import VueAnychart from '../../analytics/VueAnychart';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

export default {
  name: 'anonymousSnapshot',

  // components: {
  //   VAlert,
  //   VAvatar
  // },

  data () {
    return {
      report: {},
      table: {
        headers: ['HR name', 'Total messages', 'Conversation initiated', 'Conversation resolved']
      }
    };
  },

  mounted () {
    this.getAnonymousStats();
  },

  computed: {
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.dashboardFilters,
      updateDashboardFilters: state => state.updateDashboardFilters
    })
  },

  methods: {
    filterData (user) {
      const users = [];
      users.push(user);
      // this.filters.selected = { assignedTo__email: users };
      const temp = {
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/',
        query: {
          assignedTo: users,
          tab: 'anonymous-message',
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    getColor (e) {
      let color = 'primary';
      if (e.gender && e.gender === 'female') {
        color = 'pink';
      }
      return color;
    },
    getAvatar (c) {
      let name = '';
      if (c.anonymous_name) {
        name = c.anonymous_name.split(' ');
      } else if (c.user_name) {
        name = c.user_name.split(' ');
      }
      const avt = `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ''}`;
      return avt.toUpperCase();
    },
    getAnonymousStats () {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/dashboard?fields=anonymous_message_overview,userwise_assigned_messages,anonymity_trend`).then((response) => {
        if (response && response.data) {
          this.report = response.data.anonymous_message_overview;
          this.table.team = response.data.userwise_assigned_messages;
          this.generateAreaChart(response.data.anonymity_trend);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch user list, Please try again later!'
          });
        }
      });
    },
    generateAreaChart (data) {
      const temp = [];
      this.$lodash.each(data, (value, key) => {
        const temp2 = {};
        temp2.month = value[0];
        temp2.rate = value[1];
        temp.push(temp2);
      });
      // console.log('data', temp);
      // setTimeout(() => {
      var testChart = am4core.create('anonymityRate', am4charts.XYChart);
      /* Add data */
      testChart.data = temp;
      /* Create axes */
      var categoryAxis = testChart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'month';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 10;
      // categoryAxis.renderer.grid.template.disabled = true;
      // categoryAxis.title.text = 'Months';

      /* Create value axis */
      var valueAxis = testChart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.baseValue = 0;
      valueAxis.renderer.grid.template.disabled = true;
      // valueAxis.title.text = 'Score';
      // valueAxis.fontSize = 12;
      valueAxis.min = 0;
      // valueAxis.max = 5;

      /* Create series */
      var series1 = testChart.series.push(new am4charts.LineSeries());
      series1.dataFields.valueY = 'rate';
      series1.dataFields.categoryX = 'month';
      series1.name = 'Anonymity Rate';
      series1.strokeWidth = 3;
      series1.fill = '#050550';
      series1.stroke = am4core.color('#050550');
      series1.tensionX = 1;
      series1.fillOpacity = 0.5;
      series1.tooltipHTML = `<center><strong>Month {categoryX}</strong></center>
        <hr />
        <table>
        <tr>
          <th align="left">Anonymity Rate :</th>
          <td>{valueY}</td>
        </tr>
        </table>`;
      // eslint-disable-next-line no-unused-vars
      var bullet1 = series1.bullets.push(new am4charts.CircleBullet());
      testChart.cursor = new am4charts.XYCursor();
      // if (document.getElementById('anonymityRate')) {
      //   document.getElementById('anonymityRate').innerHTML = '';
      // }
      // create a chart
      //   const chart = Anychart.area();
      //   const series = chart.area(data);
      //   series.normal().fill('#edebf5');
      //   series.normal().stroke('#050550');
      //   // enable HTML for tooltips
      //   chart.tooltip().useHtml(true);
      //   // tooltip settings
      //   const tooltip = chart.tooltip();
      //   tooltip.positionMode('point');
      //   tooltip.title('Month: <b>{%x}');
      //   tooltip.format('Anonymity Rate: <b>{%value}</b>');
      //   chart.title('');
      //   // set the titles of the axes
      //   chart.xAxis().title('Month');
      //   chart.yAxis().title('');
      //   // set the container id
      //   chart.container('anonymityRate');
      //   // initiate drawing the chart
      //   chart.draw();
      // }, 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.anonymous-snapshot-wrap {
  margin: 0px;
  .top-cards-wrap {
    display: flex;
    overflow: hidden;
  }
  .am-card {
    width:100%;
    position:relative;
    background-color: var(--bg);
    border-radius: 6px;
    box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
    height: 16rem;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    text-align: center;
    color: var(--color-text);
    &:hover {
      transform: scale(1.05);
      // box-shadow: 10px 10px 15px rgba(0,0,0,0.3);
    }
  }
  .anonymous-employees-cards, .anm-cont {
    // box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
  }
  #anonymityRate {
    height: 470px!important;
  }
}
tbody {
    max-height:360px;
    overflow-y:scroll;
}
</style>
